module.exports = __webpack_public_path__ + "img/logo.0699d158.png";